import { takeLatest, put } from 'redux-saga/effects';
import { createAxios } from '../utils/utils';
import {
  // CLASSES_LIST_54,
  CLASS_APPS_54,
  CLASSES_LIST_73,
} from '../config';
import {
  GET_CLASSES_LIST,
  GET_CLASSES_LIST_SUCCESS,
  GET_CLASS_APPS,
  GET_CLASS_APPS_SUCCESS,
  SET_CLASS_LOADING,
} from '../constants/category';

function* fetchClassesList(params) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(CLASSES_LIST_73, { params: params.param });
    if (res && res.data && res.data.status === 0) {
      yield put({
        type: GET_CLASSES_LIST_SUCCESS,
        data: {
          list: res.data && res.data.data,
          classesSatus: true,
        },
      });
    } else {
      yield put({
        type: GET_CLASSES_LIST_SUCCESS,
        data: {
          list: [],
          classesSatus: false,
        },
      });
    }
  } catch (err) {
    yield put({
      type: GET_CLASSES_LIST_SUCCESS,
      data: {
        list: [],
        classesSatus: false,
      },
    });
  }
}

function* fetchClassApps(params) {
  // eslint-disable-next-line no-useless-catch
  try {
    yield put({ type: SET_CLASS_LOADING, loading: true });
    const axios = yield createAxios();
    const res = yield axios.get(CLASS_APPS_54, { params: params.param });
    if (res.data.status === 0) {
      const data = { ...res.data.data, loading: false, params: params.param };
      yield put({ type: GET_CLASS_APPS_SUCCESS, data });
    } else {
      yield put({ type: SET_CLASS_LOADING, loading: false });
    }
  } catch (error) {
    yield put({ type: SET_CLASS_LOADING, loading: false });
    throw error;
  }
}

export function* watchFetchClassApps() {
  yield takeLatest(GET_CLASS_APPS, fetchClassApps);
}

export function* watchFetchClassesList() {
  yield takeLatest(GET_CLASSES_LIST, fetchClassesList);
}
